import React from "react";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormSimpleStepSection from "../../components/simple-steps/FormSimpleStepSection";
import { useGetSimpleStepSection } from "../../hooks/simple-steps/useGetSimpleStepSection";
import { useUpdateSimpleStepSection } from "../../hooks/simple-steps/useUpdateSimpleStepSection";

const SimpleStepSection = () => {
    const { simpleStepSection, isLoading: isFetching } = useGetSimpleStepSection();
    const { mutate, isPending: isUpdating } = useUpdateSimpleStepSection();

    const handleSubmit = (data) => {
        mutate(data);
    };

    if (isFetching) {
        return null;
    }

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormSimpleStepSection
                currentData={simpleStepSection}
                onSubmit={handleSubmit}
                isLoading={isUpdating}
            />
        </WrapperSection>
    );
};

export default SimpleStepSection;
